// src/ds/AntdTheme.tsx — the AntD side of the token bridge.
// Maps the design tokens (./tokens) onto an AntD 6 ThemeConfig and exposes a
// provider that SCOPES the theme to the console subtree only. The legacy admin
// (outside this provider) keeps AntD defaults → zero visual regression.
import React from "react";
import { ConfigProvider, type ThemeConfig } from "antd";
import { color, font, radius, zLayer } from "./tokens";

export const eightTheme: ThemeConfig = {
  token: {
    colorPrimary: color.purple,
    colorInfo: color.info,
    colorSuccess: color.success,
    colorWarning: color.warning,
    colorError: color.danger,
    colorTextBase: color.fg1,
    colorBgLayout: color.appBg,
    colorBorder: color.border,
    colorBorderSecondary: color.border,
    borderRadius: radius.control,
    borderRadiusLG: radius.card,
    fontFamily: font.sans,
    fontSizeHeading1: 26,
    // Above the console drawers — see `zLayer`.
    zIndexPopupBase: zLayer.popup,
    wireframe: false,
  },
  components: {
    Layout: {
      bodyBg: color.appBg,
      headerBg: color.surface,
      siderBg: color.surface,
    },
    Card: { borderRadiusLG: radius.card },
    Button: { borderRadius: radius.control, controlHeight: 36 },
    Table: {
      headerBg: color.surface,
      headerColor: color.fg3,
      borderColor: color.border,
    },
  },
};

/** Wrap the console subtree. Scoped — does not affect the legacy /portal admin. */
export function ConsoleThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <ConfigProvider theme={eightTheme}>{children}</ConfigProvider>;
}

export default ConsoleThemeProvider;
